import './css/admin_notice_board.css';
import { useState, useRef, useEffect } from 'react';
import axios from 'axios';

//mui
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

//classes
class Notice {
    public url: string = '';
    public action: string = '';
    constructor(url: string, action: string) {
        this.url = url;
        this.action = action;
    }
}

//nonstate
const nonstate = {
    indexUrl: "https://www.ppkm.org.my/mobile_backend/assets/notices/index.php",
    controlUrl: "https://www.ppkm.org.my/mobile_backend/assets/notices/control.php",
    resourceUrl: "https://www.ppkm.org.my/mobile_backend/assets/notices/"
}

interface Props {}

const AdminNoticeBoard:React.FC<Props> = ({}) => {
    //states
    const [notices, SetNotices] = useState<Notice[]>([] as Notice[]);
    const [noticesSort, SetNoticesSort] = useState<string[]>([] as string[]);
    const [newPosterBase64, SetNewPosterBase64] = useState<string>('');
    const [newActionUrl, SetNewActionUrl] = useState<string>('');
    //refs
    const noticesRef = useRef<Notice[]>([] as Notice[]);
    const newPosterExtensionRef = useRef<string>('');
    const noticesSortRef = useRef<string[]>(noticesSort);
    const noticesSortStampRef = useRef<string[]>(noticesSort);
    
    //watchers
    useEffect(() => {
        FetchNoticesFromServer();
    }, []);

    //ui functions
    const OnItemSortChanged = (value: string, i: number) => {
        if(value == '' || /^-?\d+$/.test(value)) {
            noticesSortRef.current[i] = value;
        }
        SetNoticesSort([...noticesSortRef.current]);
    }
    const OnItemSortBlurred = (value: string, i: number) => {
        if(
            noticesSortStampRef.current[i].trim() != value.trim() //sorting order changed
            && /^-?\d+$/.test(value)
        ) {
            const subject = noticesRef.current[i];
            //remove subject from array
            noticesRef.current.splice(i, 1);
            //insert subject back into the array
            noticesRef.current.splice(parseInt(value), 0, subject);
            SetNotices([...noticesRef.current]);

            //sync notices with server
            const formData2 = new FormData();
            formData2.append('resyncNotices', 'true');
            formData2.append('responses', JSON.stringify(noticesRef.current));
            axios.post(nonstate.controlUrl, formData2, { withCredentials: false}).then((res: any) => {
                if(!JSON.stringify(res.data).includes('_false')) {
                    SetNotices([...noticesRef.current]);
                    alert('Successfully rearrange notices!');

                    FetchNoticesFromServer();
                } else {
                    alert('Rearrange notice failed, fail to resync notices on server.');
                }
            }).catch((err: string) => {
                alert('Rearrange notice failed, fail to resync notices on server.');
            });
        }
    }
    const OnPosterImageSelected = (file: any) => {
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                if(reader.result && typeof reader.result === "string")
                    SetNewPosterBase64(reader.result);
            };
            reader.readAsDataURL(file);

            //extract extension info
            const fileNameArr = file.name.split('.');
            newPosterExtensionRef.current = fileNameArr[fileNameArr.length - 1];
        }
    }

    //exe functions
    const FetchNoticesFromServer = () => {
        const formData = new FormData();
        formData.append('getAllNotices', 'true');

        axios.post(nonstate.indexUrl, formData, {withCredentials: false}).then((res: any) => {
            let resObjs = [] as any[];
            try {
                resObjs = JSON.parse(res.data) as any[];
            } catch {
                resObjs = res.data as any[];
            }
            noticesRef.current = [];
            noticesSortRef.current = [];
            noticesSortStampRef.current = [];
            resObjs.map((resObj: any, i: number) => {
                noticesRef.current.push(new Notice(resObj['url'], resObj['action']));
                noticesSortRef.current.push(i.toString());
                noticesSortStampRef.current.push(i.toString());
            });
            SetNotices([...noticesRef.current]);
            SetNoticesSort([...noticesSortRef.current]);
        }).catch((err: string) => {
            console.log('GetAllNoticesErr: ' + err);
        });
    }
    const ProceedRemoveNotice = (i: number) => {
        const subject = noticesRef.current[i];
        const urlArr = subject.url.split('/');
        //remove posterimage from server
        const formData = new FormData();
        formData.append('removeImage', 'true');
        formData.append('fileName', urlArr[urlArr.length - 1]);
        axios.post(nonstate.controlUrl, formData, { withCredentials: false}).then((res: any) => {
            if(!JSON.stringify(res.data).includes('_false')) {
                //remove subject from noticesRef
                noticesRef.current.splice(i, 1);
                //resync notices
                const formData2 = new FormData();
                formData2.append('resyncNotices', 'true');
                formData2.append('responses', JSON.stringify(noticesRef.current));
                axios.post(nonstate.controlUrl, formData2, { withCredentials: false}).then((res: any) => {
                    if(!JSON.stringify(res.data).includes('_false')) {
                        SetNotices([...noticesRef.current]);
                        alert('Successfully removed a notice!');
                    } else {
                        alert('Remove notice failed, fail to resync notices on server.');
                    }
                }).catch((err: string) => {
                    alert('Remove notice failed, fail to resync notices on server.');
                });
            } else {
                alert('Remove notice failed, failed to remove poster image from server.');
            }
        }).catch((err: string) => {
            alert('Remove notice failed, failed to remove poster image from server.');
        });
    }
    const ProceedCreateNotice = () => {
        if(newPosterBase64.length > 0) {
            //newPosterFilename
            const fileName = FilenameGen() + '.' + newPosterExtensionRef.current
            //upload image to server
            const formData = new FormData();
            formData.append('addImage', 'true');
            formData.append('base64', newPosterBase64);
            formData.append('fileName', fileName);
            axios.post(nonstate.controlUrl, formData, {withCredentials: false}).then((res: any) => {
                if(!JSON.stringify(res.data).includes('_false')) {
                    //add subject to noticesRef
                    const subject = new Notice(nonstate.resourceUrl + fileName, newActionUrl);
                    noticesRef.current.unshift(subject);

                    //resync notices
                    const formData2 = new FormData();
                    formData2.append('resyncNotices', 'true');
                    formData2.append('responses', JSON.stringify(noticesRef.current));
                    axios.post(nonstate.controlUrl, formData2, { withCredentials: false}).then((res: any) => {
                        if(!JSON.stringify(res.data).includes('_false')) {
                            SetNotices([...noticesRef.current]);
                            alert('Successfully created a new notice!');

                            ResetNoticeCreation();
                        } else {
                            alert('Add notice failed, fail to resync notices on server.');
                        }
                    }).catch((err: string) => {
                        alert('Add notice failed, fail to resync notices on server.');
                    });
                } else {
                    alert('Notice creation fail, failed to add image to server.');
                }
            })
        } else {
            alert('Notice creation fail, you must add a poster image.');
        }
    }
    const FilenameGen = (length = 16) => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * chars.length);
            result += chars[randomIndex];
        }
        return result;
    }
    const ResetNoticeCreation = () => {
        SetNewPosterBase64('');
        SetNewActionUrl('');
        newPosterExtensionRef.current = '';
    }

    return(
        <div className='AdminNoticeBoard'>
            <span className='title-lbl'>Notice Board Items</span>
            <div className='item-table'>
                <div className='item-table-header'>
                    <span className='item-lbl ex'>Sort No.</span>
                    <span className='item-lbl ex _3'>Poster</span>
                    <span className='item-lbl ex _4'>Action Url</span>
                    <span className='item-lbl ex'>Operations</span>
                </div>
                <div className='item-table-scroll'>
                    {
                        notices.map((notice: Notice, i: number) => {
                            return(
                                <div className='item-table-row'>
                                    <input className='item-in' value={noticesSort[i] != '' ? noticesSort[i] : ''} onChange={(e: any) => OnItemSortChanged(e.target.value, i)} onBlur={(e: any) => OnItemSortBlurred(e.target.value, i)}/>
                                    <img className='item-img _3' src={notice.url}/>
                                    <a className='item-link _4' href={notice.action} target="_blank">{notice.action}</a>
                                    <button className='item-btn' onClick={() => {
                                        if(window.confirm("Are you sure you want to remove this notice?")) {
                                            ProceedRemoveNotice(i)
                                        }
                                    }}><DeleteIcon /> Delete</button>
                                </div>
                            )
                        })
                    }
                </div>
                <div className='item-table-footer'>
                    <span className='item-lbl ex2'>New Notice</span>
                    <div className='item-table-col'>
                        <input className='item-in ex' type='file' accept="image/*" onChange={(e: any) => OnPosterImageSelected(e.target.files[0])} multiple={false}/>
                        <img className='item-img' src={newPosterBase64}/>
                    </div>
                    <textarea className='item-area _4' value={newActionUrl} placeholder='Action Link' onChange={(e: any) => SetNewActionUrl(e.target.value)}/>
                    <button className='item-btn' onClick={() => {
                        if(window.confirm("Are you sure you want to create this notice?")) {
                            ProceedCreateNotice()
                        }
                    }}><AddIcon/> Create</button>
                </div>
            </div>
        </div>
    )
}
export default AdminNoticeBoard;